import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

import { SharedModule } from '@blaze-shared/shared-feature';
import { TooltipDirective } from '@blaze-shared/shared-ui';

import { AvailabilityTimePickerComponent } from './availability-time-picker/availability-time-picker.component';

@Component({
  selector: 'blaze-times-range-picker',
  templateUrl: './times-range-picker.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule, AvailabilityTimePickerComponent, TooltipDirective, SharedModule],
  host: { class: 'flex items-center gap-8' },
})
export class TimesRangePickerComponent {
  value = input.required<{ from: string; to: string }>();
  error = input.required<string | undefined>();
  valueChanged = output<{ from: string; to: string }>();

  onValueChanged(event: string | null, field: 'from' | 'to'): void {
    this.valueChanged.emit({ ...this.value(), [field]: event });
  }
}
